"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProduct = createProduct;
async function createProduct(productRepo, product) {
    return await productRepo.createProduct(product);
}
